module.exports = __webpack_public_path__ + "img/home_modal_2.d92786ea.png";